export function validateCandleBreak(data) {
  const { candleDuration, quantityBasisValue } = data;
  if (
    !candleDuration ||
    candleDuration <= 0 ||
    !Number.isInteger(candleDuration)
  )
    return [
      false,
      'Please enter a positive, whole number for candle duration.',
    ];
  if (!quantityBasisValue || quantityBasisValue <= 0)
    return [false, 'Quantity Basis value must be a number larger than zero.'];
  return [true, ''];
}
